import React, { useState, useEffect } from 'react';
import { Button, Row } from 'reactstrap';
import moment from 'moment/moment';

// Constants
import { actionsTable } from '../../../constants/MaterialTable';

// Componentes
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import FichaRequerimento from '../../Shared/FichaRequerimento';
import MainCard from "../../../components/MainCard";
// API
import requerimento_api from '../../../api/requerimento';

// Helpers
import { showMessage } from "../../../helpers/message"
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Context
import { useAuth } from '../../../context/auth';

export default function MeuCadastro() {
    // state para loading
    const { setLoading } = useAuth();

    //Estado de controle da lista de requerimentos
    const [requerimentos, setRequerimentos] = useState([]);

    // state para seta o requerimento de consulta
    const [requerimentoId, setRequerimentoId] = useState(null);

    //Cabeçalhos que a tabela terá
    const headers = [
        { value: "Tipo", objectValue: "tipoRequerimento", align: "left" },
        { value: "Data", objectValue: "dataRequerimento", align: "left" },
        { value: "Número do Requerimento", objectValue: "numeroRequerimento", align: "left" },
        { value: "Status", objectValue: "situacao", align: "left" },
        { value: "Etapa", objectValue: "etapa", align: "left" },
        { value: "Endereço", objectValue: "endereco", align: "left" }
    ]

    //Função do botão visualizar da lista
    const editar = (row) => {
        setRequerimentoId(row.id);
    };

    //Ações que a tabela terá
    const actions = [actionsTable.visualizar(editar)];

    const handleVoltar = () => {
        setRequerimentoId(null);
    }

    useEffect(() => {
        setLoading(true);
        requerimento_api.getList({}).then(response => {
            response.data = response.data.map(value => {
                value.dataRequerimento = moment(value.dataRequerimento).format("DD/MM/YYYY");
                return value;
            });
            setRequerimentos(response.data);
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }, []);
    return (
        <>
            <Row style={{ color: "#666" }} className='mt-5'>
                {
                    !requerimentoId && <TabelaListagem
                        actions={actions}
                        title={"Lista de requerimentos"}
                        options={{ print: false, search: true, pagination: true }}
                        headers={headers}
                        items={requerimentos}
                    />
                }
            </Row>
            {!!requerimentoId &&
                <FichaRequerimento
                    requerimentoId={requerimentoId}
                    btnVoltar={handleVoltar}
                />
            }
        </>
    )
}